export default function (campaign, { index, type }) {
  const selectedMessage = campaign?.[type];

  if (Array.isArray(selectedMessage)) {
    return selectedMessage[index];
  }

  return selectedMessage;
}